// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".saas-tab{line-height:1.8rem;display:flex;border-bottom:.1rem solid rgba(51,118,255,.28);position:relative}.saas-tab li{text-align:center;cursor:pointer}.saas-tab .active-line{position:absolute;bottom:-.1rem;height:.1rem;background:#43adff;transition:left .3s ease-out}", ""]);
// Exports
module.exports = exports;
